
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCog, faEnvelopeOpen, faSearch, faSignOutAlt, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Row, Col, Nav, Form, Image, Navbar, Dropdown, Container, ListGroup, InputGroup, Button, OverlayTrigger, Tooltip } from '@themesberg/react-bootstrap';
import Swal from 'sweetalert2';
import { readSuperAdminSession, reloadSessionPage, returnToSuperAdmin, signOutSession } from '../utils/authSession';

import { isSuperAdmin, readSessionAdmin } from '../utils/userPermissions';

import NOTIFICATIONS_DATA from "../data/notifications";
import Profile3 from "../assets/img/team/profile-picture-3.jpg";
import DummyImage from "../assets/img/team/dummy-pic.png";
import NotifiIcon from "../assets/img/top_iconalert.svg";
import logout from "../assets/img/logout.svg";
import UserIcon from "../assets/img/icon_user.svg";

export default (props) => {
  const [notifications, setNotifications] = useState(NOTIFICATIONS_DATA);
  const areNotificationsRead = notifications.reduce((acc, notif) => acc && notif.read, true);

  const [sessionChanging, setSessionChanging] = useState(false);
  const isImpersonating = Boolean(readSuperAdminSession());

  const rawName = sessionStorage.getItem('quoteloginusername');
  const loginName = rawName?.replace(/^"|"$/g, '');

  const loggedInAdmin = props.admin ?? readSessionAdmin();
  const loggedInAdminRoleName = loggedInAdmin?.role_name || loggedInAdmin?.role?.name;
  const vendorName = !isSuperAdmin(loggedInAdmin) ? loggedInAdmin?.vendor?.name?.trim() : null;

  const markNotificationsAsRead = () => {
    setTimeout(() => {
      setNotifications(notifications.map(n => ({ ...n, read: true })));
    }, 300);
  };


  const Notification = (props) => {
    const { link, sender, image, time, message, read = false } = props;
    const readClassName = read ? "" : "text-danger";

    return (
      <ListGroup.Item action href={link} className="border-bottom border-light">
        <Row className="align-items-center">
          <Col className="col-auto">
            <Image src={image} className="user-avatar lg-avatar rounded-circle" />
          </Col>
          <Col className="ps-0 ms--2">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="h6 mb-0 text-small">{sender}</h4>
              </div>
              <div className="text-end">
                <small className={readClassName}>{time}</small>
              </div>
            </div>
            <p className="font-small mt-1 mb-0">{message}</p>
          </Col>
        </Row>
      </ListGroup.Item>
    );
  };

  const handleSignOut = async () => {
    if (sessionChanging) return;
    setSessionChanging(true);
    await signOutSession();
    reloadSessionPage('/sign-in');
  };

  const handleReturnToSuperAdmin = async () => {
    if (sessionChanging) return;
    setSessionChanging(true);
    try {
      const restored = await returnToSuperAdmin();
      reloadSessionPage(restored ? '/admin' : '/sign-in');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Unable to return to Super Admin',
        text: error.response?.data?.message || error.message || 'Please try again.',
      });
      setSessionChanging(false);
    }
  };

  return (
    <Navbar variant="light" expanded className="py-2 px-3 top-navbar">
      <Container fluid className="px-0">
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between w-100">
          <div className="vendor-session-controls d-flex flex-wrap gap-2 align-items-center">
            {isImpersonating && (
              <>
                <span className="vendor-session-label" role="status">Logged in as vendor: {loginName}</span>
                <Button
                  type="button"
                  variant="primary"
                  className="vendor-session-return"
                  size="sm"
                  onClick={handleReturnToSuperAdmin}
                  disabled={sessionChanging}
                >
                  {sessionChanging ? 'Please wait...' : 'Return to Super Admin'}
                </Button>
              </>
            )}
            {/* <Form className="navbar-search">
              <Form.Group id="topbarSearch">
                <InputGroup className="input-group-merge search-bar">
                  <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                  <Form.Control type="text" placeholder="Search" />
                </InputGroup>
              </Form.Group>
            </Form> */}
          </div>
          {/* <Nav className="align-items-center">
            <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead} >
              <Dropdown.Toggle as={Nav.Link} className="text-dark icon-notifications me-lg-3">
                <span className="icon icon-sm">
                  <FontAwesomeIcon icon={faBell} className="bell-shake" />
                  {areNotificationsRead ? null : <span className="icon-badge rounded-circle unread-notifications" />}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0">
                <ListGroup className="list-group-flush">
                  <Nav.Link href="#" className="text-center text-primary fw-bold border-bottom border-light py-3">
                    Notifications
                  </Nav.Link>

                  {notifications.map(n => <Notification key={`notification-${n.id}`} {...n} />)}

                  <Dropdown.Item className="text-center text-primary fw-bold py-3">
                    View all
                  </Dropdown.Item>
                </ListGroup>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <Image src={DummyImage} className="user-avatar md-avatar rounded-circle" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{loginName}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item className="fw-bold">
                  <FontAwesomeIcon icon={faUserCircle} className="me-2" /> My Profile
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold">
                  <FontAwesomeIcon icon={faCog} className="me-2" /> Settings
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold">
                  <FontAwesomeIcon icon={faEnvelopeOpen} className="me-2" /> Messages
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold">
                  <FontAwesomeIcon icon={faUserShield} className="me-2" /> Support
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item onClick={handleSignOut} className="fw-bold">
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav> */}

          <nav className="ms-sm-auto">
            <ul className="d-flex align-items-center m-0 list-unstyled">

              {/* User Info */}
              <li className="nav-item d-flex align-items-center me-2">
                <div className="nav-profile d-flex flex-column align-items-end pe-0 me-3">
                  <p className="m-0 font-600 font-14 top-navbar__name">{loginName}</p>
                  <span className="small font-500 font-12 top-navbar__role">{loggedInAdminRoleName}</span>
                </div>
                {vendorName ? (
                  <OverlayTrigger
                    placement="bottom"
                    trigger={['hover', 'focus']}
                    overlay={<Tooltip id="profile-vendor-tooltip">Vendor: {vendorName}</Tooltip>}
                  >
                    <span
                      className="d-inline-flex rounded-circle"
                      tabIndex={0}
                      role="img"
                      aria-label={`User profile. Vendor: ${vendorName}`}
                    >
                      <img src={UserIcon} alt="" className="rounded-circle icon" />
                    </span>
                  </OverlayTrigger>
                ) : (
                  <img src={UserIcon} alt="User Icon" className="rounded-circle icon" />
                )}
              </li>

              {/* Notification Icon */}
              <li className="nav-item position-relative mx-3">
                <img className="notify icon" src={NotifiIcon} alt="Notifications" />
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                  {/* {Noticount} */}
                </span>
              </li>

              {/* Logout */}
              <li className="nav-item d-flex pe-0">
                <Button
                  type="button"
                  variant="link"
                  className="p-0 border-0"
                  aria-label="Logout"
                  onClick={handleSignOut}
                  disabled={sessionChanging}
                >
                  <img src={logout} alt="" className="logout icon" />
                </Button>
              </li>

            </ul>
          </nav>

        </div>
      </Container>
    </Navbar>
  );
};
